module.exports = __webpack_public_path__ + "static/media/28.e0173f5c.JPG";